import { render } from "./ActivityPanel.vue?vue&type=template&id=18c5dbe1&scoped=true"
import script from "./ActivityPanel.vue?vue&type=script&lang=js"
export * from "./ActivityPanel.vue?vue&type=script&lang=js"

import "./ActivityPanel.vue?vue&type=style&index=0&id=18c5dbe1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c5dbe1"]])

export default __exports__